import { render } from "./CheckOutCampaing.vue?vue&type=template&id=82db3574&scoped=true"
import script from "./CheckOutCampaing.vue?vue&type=script&lang=js"
export * from "./CheckOutCampaing.vue?vue&type=script&lang=js"

import "./CheckOutCampaing.vue?vue&type=style&index=0&id=82db3574&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82db3574"]])

export default __exports__